import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import { TenantProvider } from './context/TenantContext.jsx';
import { AuthProvider } from './context/AuthContext.jsx';
import { I18nProvider } from './context/I18nContext.jsx';
import { ThemeProvider } from './context/ThemeContext.jsx';
import { BrandingProvider } from './context/BrandingContext.jsx';
import { ToastProvider } from './context/ToastContext.jsx';
import './shared/styles/app.css';

// Provider nesting note: TenantProvider has no dependencies, so it sits
// outermost. AuthProvider comes next because both I18nProvider (needs
// user.language / tenant.defaultLanguage) and ThemeProvider (needs the
// authenticated user to PATCH /users/me) read the auth session via
// useAuth(), which requires AuthProvider to be an ancestor. BrandingProvider
// needs TenantContext (pre-login tenant slug guess), AuthContext (post-login
// tenant.logoUrl/primaryColor), and I18nContext (active language for the
// pre-login welcome message). ToastProvider has no dependencies on the
// others -- innermost only because it renders its notification container
// as a sibling of <App>, so nothing about ordering actually matters here.
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <TenantProvider>
      <AuthProvider>
        <I18nProvider>
          <ThemeProvider>
            <BrandingProvider>
              <ToastProvider>
                <App />
              </ToastProvider>
            </BrandingProvider>
          </ThemeProvider>
        </I18nProvider>
      </AuthProvider>
    </TenantProvider>
  </StrictMode>
);
